import React, { useCallback } from 'react';
import ScreenChatPanel from 'components/ai/ScreenChatPanel';
import { postDeptAiChat } from 'services/aiChat';
import { isBdApiEnabled } from 'config/bdApiConfig';

const WELCOME =
  '로그인 기관 부서만 조회·등록·수정·폐지할 수 있습니다.\n예) 부서 목록 보여줘\n예) 부서코드 2000, 부서명 기획팀, 상위 1000 추가해줘';

/**
 * 기준정보 > 조직관리 > 부서관리 전용 업무 챗
 */
const AiDeptChatPanel = ({ prefsUserId, onMutated }) => {
  const apiOn = isBdApiEnabled();

  const send = useCallback(
    async (payload) => {
      if (!apiOn) {
        return { type: 'error', message: 'API 모드에서만 사용할 수 있습니다.' };
      }
      return postDeptAiChat(payload);
    },
    [apiOn]
  );

  return (
    <ScreenChatPanel
      title="부서 도우미"
      hint="로그인 기관만 · 쓰기는 확인 후 반영"
      welcome={WELCOME}
      placeholder="부서 목록 보여줘"
      storagePrefix="deptAiChatCollapsed"
      prefsUserId={prefsUserId}
      send={send}
      onDone={onMutated}
    />
  );
};

export default AiDeptChatPanel;
